
export const USER_LOGOUT = "x/USER_LOGOUT";
export function userLogout () {
    return {
        type: USER_LOGOUT
    };
}